/// <reference types="@types/googlemaps" />

import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from 'src/app/services/request.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Chart, ChartTypeRegistry } from 'chart.js/auto';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { OtherService } from 'src/app/services/other.service';

declare var google: any;

@Component({
  selector: 'app-single-plot',
  templateUrl: './single-plot.component.html',
  styleUrls: ['./single-plot.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SinglePlotComponent implements OnInit {
  plot: any = [];
  displayedColumns: string[] = ['plot_code', 'municipal_community', 'location', 'regional_unit', 'co_ownership', 'size', 'mapped_background', 'eco_schemes.scheme_code'];
  displayedColUrugay: string[] = ['plot_code', 'location', 'size'];
  plotCode: any;
  langStatus: any;
  expandedPanelIndex: number = 0;
  ecoSchemes: any[] = []

  treatmentColumns: string[] = ['lastTreatment', 'treatment', 'start_date', 'end_date'];
  treatmentData: any = [];

  irrigationColumns: string[] = ['lastIrrigation', 'irrigation_method', 'quantity', 'datetime'];
  irrigationData: any = [];

  fertilisationColumns: any[] = ['lastFertilisation', 'chemical_composition', 'amount_applied', 'datetime'];
  fertilisationData: any = [];

  sprayingColumns: any[] = ['lastSpraying', 'commercial_name', 'amount_applied', 'datetime'];
  sprayingData: any = [];

  harvestColumns: any[] = ['lastHarvest', 'cleaning_of_harvesting_equipment', 'summ', 'datetime'];
  harvestData: any = [];

  residuesColumns: any[] = ['lastResidues', 'management_method', 'total_amount', 'datetime'];
  residuesData: any = [];

  devices: any[] = []
  sensors: any[] = [];

  plotDevices: any[] = [];
  buttonStates: { [key: string]: boolean } = {};
  spinner: boolean = false
  @ViewChild('lineCanvas') private lineCanvas!: ElementRef;
  lineChart: any;
  chart!: Chart;
  chartData: any[] = [];
  chartOptions: any = {};
  chartLineData1: any[] = [];
  chartLineData2: any[] = [];
  deviceComponents: any[] = [];
  componentsD: any[] = [];
  deviceID: any;
  lastDeviceComponents: any[] = [];
  phComponentPublic: any[] = [];
  t12ComponentPublic: any[] = [];
  sensorsButtons: boolean = false
  plotDevicesID: any[] = [];
  phFlag: boolean = false
  device_type: string = '';
  buttonStates2: { [key: string]: boolean }[] = [];
  firstDeviceID: string = ''
  npkComponentPublic: any[] = [];
  aggFlag: boolean = false;
  newTerros12: any[] = [];
  startDate!: string;
  endDate!: string;

  constructor(
    private route: ActivatedRoute,
    private req: RequestService<any>,
    public translate: TranslateService,
    private datepipe: DatePipe,
    public featureFlags: FeatureFlagsService,
    public dateRangeService: OtherService
  ) {
  }

  ngOnInit(): void {
    const plotId = this.route.snapshot.paramMap.get('id');
    this.req.getPlot(plotId).subscribe((res) => {
      this.plotDevicesID = res.devices
      this.plot = res;
      this.plotDevices.push(res)
      const defaultId = this.plot.crop_info[0].crop_info_id;
      this.updateTables(defaultId);
      this.ecoSchemes.push(res)
      this.plot.size = this.plot.size.toFixed(1)
      this.plotCode = this.plot.plot_code;
      this.initChart();
      this.initMap();
      this.initValues();
    });
    const { startDate, endDate } = this.dateRangeService.getOneMonthDateRange();
    this.startDate = startDate;
    this.endDate = endDate;
  }

  initMap(): void {
    this.req.getDevices().subscribe(res => {
      const filterArray = res.filter(device => this.plotDevicesID.includes(device.attributes.uuid));
      this.devices = filterArray;
      if (this.plot && this.plot.map_coordinates && Array.isArray(this.plot.map_coordinates) && this.plot.map_coordinates.length > 0) {
        const mapCenter = {
          lat: parseFloat(this.devices[0]?.attributes.lat),
          lng: parseFloat(this.devices[0]?.attributes.lon)
        };
        const map = new google.maps.Map(document.getElementById("map")!, {
          zoom: 14,
          center: mapCenter,
          mapTypeId: google.maps.MapTypeId.SATELLITE,
          mapTypeControl: false,
          streetViewControl: false
        });
        const pathCoordinates: google.maps.LatLngLiteral[] = this.plot.map_coordinates.map((coord: any) => ({
          lat: +coord.lat,
          lng: +coord.lon
        }));
        if (this.plot.map_coordinates.length >= 3) {
          const firstNode = this.plot.map_coordinates[0];
          pathCoordinates.push({ lat: +firstNode.lat, lng: +firstNode.lon });
        }
        const plotPolygon = new google.maps.Polygon({
          paths: pathCoordinates,
          geodesic: true,
          strokeColor: "rgb(150, 231, 178)",
          strokeOpacity: 1.0,
          fillOpacity: 0.35,
          strokeWeight: 2,
          fillColor: "#FFC107",
        });
        this.sensors = this.devices.map(device => device.attributes.components.map((component: any, index: any) => ({
          lat: parseFloat(device.attributes.lat),
          lng: parseFloat(device.attributes.lon),
          message: `
                    <div class="info-window-content" style="overflow-x: hidden; overflow-y: hidden; min-width: 280px; min-height:100px">
                        <button id="closeInfoWindow" style="position: absolute; top: 5px; right: 5px; font-weight: 600;color: #626f82;">X</button>
                        <h3 id="mapTitle" style="font-size: small;font-weight: 600;color: #626f82;margin-top: -3px;">${device.attributes.name}</h3>
                        <mat-list>
                            <div mat-line><span id="mapTitle">Status:</span> <span id="mapKeys">${device.attributes.status ? 'Active' : 'Inactive'}</span></div>
                            <mat-list-item>
                                <div mat-line><span id="mapTitle">Location:</span> <span id="mapKeys">${this.plot.location}</span></div>
                            </mat-list-item>
                            <mat-list-item>
                                <div mat-line><span id="mapTitle">Installed:</span> <span id="mapKeys">${this.datepipe.transform(device.attributes.created_at, 'medium')}</span></div>
                            </mat-list-item>
                        </mat-list>
                        <div class="p-1">
                            <div class="img-fluid rounded-rectangle img-thumbnail" style="display: flex; justify-content: center; align-items: center; font-size: x-small; text-align: center; font-weight: 600; background-color: rgb(191, 248, 211); border: 1px solid rgb(255, 255, 255); box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; width: 51px; border-radius: 4px;">
                                <p id="sensorsTitle">${component.sensor_type}</p>
                            </div>
                        </div>
                    </div>
                `,
          color: 'rgb(150, 231, 178)',
          markerIcon: ''
        }))).flat();
        this.sensors.forEach(sensor => {
          const sensorPolyline = new google.maps.Polyline({
            path: [{ lat: sensor.lat, lng: sensor.lng }, { lat: sensor.lat, lng: sensor.lng }],
            geodesic: true,
            strokeColor: sensor.color,
            strokeOpacity: 2,
            strokeWeight: 25,
            fillColor: sensor.color,
            fillOpacity: 0.35,
          });
          const marker = new google.maps.Marker({
            position: { lat: sensor.lat, lng: sensor.lng },
            map: map,
            icon: sensor.markerIcon,
            title: 'Sensor Marker'
          });
          const infoWindow = new google.maps.InfoWindow({
            content: sensor.message,
            ariaLabel: "Uluru",
          });
          google.maps.event.addListener(infoWindow, 'domready', () => {
            document.getElementById('closeInfoWindow')?.addEventListener('click', () => {
              infoWindow.close();
            });
          });
          marker.addListener('click', () => {
            infoWindow.open(map, marker);
          });
          sensorPolyline.setMap(map);
        });
        plotPolygon.setMap(map);
      }
    });
  }

  calculateCenter(coordinates: { kombos: string | number; lat: string | number; lon: string | number }[]): google.maps.LatLngLiteral {
    let totalLat = 0;
    let totalLon = 0;
    coordinates.forEach(coord => {
      totalLat += +coord.lat;
      totalLon += +coord.lon;
    });
    const averageLat = totalLat / coordinates.length;
    const averageLon = totalLon / coordinates.length;
    return { lat: averageLat, lng: averageLon };
  }

  getColumnLabel(column: string): any {
    switch (column) {
      case 'plot_code':
        return 'HOME.CODE';
      case 'municipal_community':
        return 'HOME.MUNICIPAL';
      case 'location':
        return 'HOME.LOCATION';
      case 'regional_unit':
        return 'HOME.UNIT';
      case 'co_ownership':
        return 'HOME.OWN';
      case 'size':
        return 'HOME.ACRE';
      case 'mapped_background':
        return 'HOME.MAPPED';
      case 'eco_schemes.scheme_code':
        return 'HOME.ECO_SCHEMES';
      default:
        return '';
    }
  }

  getPropertyValue(column: string) {
    return this.plot[column];
  }

  togglePanel(index: number): void {
    if (this.expandedPanelIndex === index) {
      this.expandedPanelIndex = -1;
    } else {
      this.expandedPanelIndex = index;
    }

    const selectedCropInfoId = this.plot.crop_info[index].crop_info_id;
    this.updateTables(selectedCropInfoId)
  }

  updateTables(id: string) {
    this.req.getPlotTreatment(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestTreatment = res[res.length - 1];
        this.treatmentData = [latestTreatment];
      }
    });

    this.req.getPlotIrrigation(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestIrrigation = res[res.length - 1];
        this.irrigationData = [latestIrrigation];
      }
    });

    this.req.getPlotFertilisation(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestFertilisation = res[res.length - 1];
        this.fertilisationData = [latestFertilisation];
      }
    });

    this.req.getPlotSpraying(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestSpraying = res[res.length - 1];
        this.sprayingData = [latestSpraying];
      }
    });

    this.req.getPlotHarvest(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestHarvest = res[res.length - 1];
        this.harvestData = [latestHarvest];
      }
    });

    this.req.getPlotResidues(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestResidues = res[res.length - 1];
        this.residuesData = [latestResidues];
      }
    });
  }

  initChart() {
    this.lineChart = new Chart(this.lineCanvas.nativeElement, {
      type: 'line',
      data: {
        labels: [],
        datasets: [
          {
            label: 'PH',
            data: [],
            borderColor: 'rgba(73, 215, 255)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(99, 216, 248, 0.455)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: '#1f90ec'
          },
          {
            label: 'Temperature °C',
            data: [],
            borderColor: 'rgba(205, 84, 75)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(205, 84, 75, 0.207)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(205, 84, 75)'
          },
          {
            label: 'EC μS/cm',
            data: [],
            borderColor: 'rgba(67, 84, 147)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(67, 84, 147, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(67, 84, 147)'
          },
          {
            label: 'Soil Moisuture %',
            data: [],
            borderColor: 'rgba(255,199,31)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(255,199,31, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(255,199,31)'
          },
          {
            label: 'Nitrogen (PPM)',
            data: [],
            borderColor: 'rgba(40, 127, 71)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(40, 127, 71, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(40, 127, 71)'
          },
          {
            label: 'Phosphorus (PPM)',
            data: [],
            borderColor: 'rgba(40, 127, 71)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(40, 127, 71, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(40, 127, 71)'
          },
          {
            label: 'Potassium (meqk/100g)',
            data: [],
            borderColor: 'rgba(40, 127, 71)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(40, 127, 71, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(40, 127, 71)'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              // color: 'grey',
              font: {
                size: 8,
                family: 'Arial'
              }
            },
            grid: {
              color: 'lightgray',
              lineWidth: 0.1
            }
          },
          y: {
            display: true,
            ticks: {
              color: 'grey',
              font: {
                size: 8,
                family: 'Arial'
              }
            },
            grid: {
              color: 'lightgray',
              lineWidth: 0.3
            }
          }
        }
      }
    });
  }



  initValues() {
    this.spinner = true;
    const device_type = 'PH';
    this.plotDevices.forEach(plotDevice => {
      this.firstDeviceID = plotDevice.devices[0]
      plotDevice.devices.forEach((device: any, index: any) => {
        this.buttonStates[device] = index === 0;
      });
    });
    this.req.getDevices(this.firstDeviceID).subscribe(res => {
      if (res) {
        this.spinner = false
        this.sensorsButtons = true
        this.phFlag = true
      }
      this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
      this.lineChart.update();
      this.componentsD.push(res)
      this.initSensor()
    });
  }

  initSensor() {
    this.sensorsButtons = true;
    this.device_type = 'PH';
    const ArraySensorType: any[] = [];
    ArraySensorType.push('sensor_type=' + 'PH');
    this.lineChart.options.plugins.legend.labels.filter = (item: any) => {
      if (this.device_type.includes("PH") && item.datasetIndex === 0) {
        return true;
      }
      return false;
    };
    this.lineChart.update();

    this.req.getDevicesOverall2(this.firstDeviceID, ArraySensorType, this.startDate, this.endDate).subscribe(res => {
      if (res.length > 0) {
        this.spinner = false;
        const lastObject = res.slice(-1)[0];
        this.phComponentPublic = [lastObject];
        this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic, ...this.npkComponentPublic];
        res.forEach(el => {
          this.lineChart.data.labels.push(this.datepipe.transform(el.attributes.measurement_time, 'dd/MM/yyyy HH:mm'));
          this.lineChart.data.datasets[0].data.push(el.attributes.renke[0].value);
        });
      }
      this.lineChart.update();
      this.buttonStates2 = this.componentsD.map(group => {
        let groupButtonStates: { [key: string]: boolean } = {};
        group.attributes.components.forEach((button: any) => {
          if (button.sensor_type === 'PH' && this.device_type === 'PH') {
            groupButtonStates[button.sensor_type] = true;
            button.isOn = true;
          } else {
            groupButtonStates[button.sensor_type] = false;
            button.isOn = false;
          }
        });
        if (!Object.values(groupButtonStates).includes(true)) {
          const firstButton = group.attributes.components[0];
          groupButtonStates[firstButton.sensor_type] = true;
          firstButton.isOn = true;
        }
        return groupButtonStates;
      });
    });
  }

  chooseDevice(event: any, button: any) {
    this.device_type = ''
    this.buttonStates2 = [{ ph: false, t12: false }]
    this.spinner = true
    this.buttonStates[button] = event.source._checked;
    this.lineChart.data.datasets[0].data = []
    this.deviceID = button
    this.componentsD = [];
    this.lineChart.data.labels = [];
    this.phComponentPublic = [];
    this.lineChart.data.datasets[0].data = [];

    if (this.buttonStates[button]) {
      this.req.getDevices(button).subscribe(res => {
        if (res) {
          this.initSensor();
          this.spinner = false
          this.sensorsButtons = true
        }
        this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
        this.lineChart.update();
        this.componentsD.push(res)
      });
    } else {
      this.spinner = false
      this.componentsD = [];
      this.lineChart.data.labels = [];
      this.phComponentPublic = [];
      this.lineChart.data.datasets[0].data = [];
      this.lineChart.update();
    }

    Object.keys(this.buttonStates).forEach(key => {
      if (key !== button) {
        this.buttonStates[key] = false;
      }
    });
    this.componentsD = [];
    this.lastDeviceComponents = [];
    this.componentsD = [];
    this.lineChart.data.labels = [];
    this.phComponentPublic = [];
    this.lineChart.data.datasets[0].data = [];
  }


  chooseSensor(event: any, button: any, groupIndex: number, sens: any) {
    this.spinner = true;
    this.lineChart.data.labels = [];
    this.lineChart.data.datasets.forEach((dataset: any) => dataset.data = []);
    this.deviceID = sens.id
    this.deviceComponents = [];
    button.isOn = event.source._checked;
    this.buttonStates2[groupIndex][button.sensor_type] = button.isOn;
    const ArraySensorType: any[] = [];
    sens.attributes.components.forEach((el: any) => {
      if (el.isOn) {
        ArraySensorType.push('sensor_type=' + el.sensor_type);
      }
    });
    if (ArraySensorType.length > 0) {
      this.req.getDevicesOverall2(this.deviceID, ArraySensorType, this.startDate, this.endDate).subscribe(res => {
        this.spinner = false;
        this.aggFlag = false
        this.lastDeviceComponents = [res.slice(-1)[0]];
        res.forEach((el: any) => {
          if (el.attributes) {
            this.lineChart.data.labels.push(this.datepipe.transform(el.attributes.measurement_time, 'dd/MM/yyyy HH:mm'));
            if (el.attributes.renke) {
              this.lineChart.data.datasets[0].data.push(el.attributes.renke[0].value);
            }
            if (el.attributes.terros_12) {
              this.newTerros12 = []
              const newTerros12 = el.attributes.terros_12.map((sensor: any) => {
                if (sensor.name.includes("temperature")) {
                  sensor.name = "Temperature";
                  sensor.unit = sensor.unit;
                  sensor.value = sensor.value;
                } else if (sensor.name == "bulk_electrical_conductivity") {
                  sensor.name = "EC";;
                  sensor.unit = sensor.unit;
                  sensor.value = sensor.value;
                } else if (sensor.name == "transformed_mineral_soil") {
                  sensor.name = "Soil Moisture";
                  sensor.unit = '%';
                  sensor.value = (sensor.value * 100).toFixed(1);
                }
                return {
                  name: sensor.name,
                  unit: sensor.unit,
                  value: sensor.value
                };
              });
              newTerros12.forEach((el: any) => {
                if (el.name.includes("Temperature") || el.name.includes("EC") || el.name.includes("Moisture")) {
                  this.newTerros12.push(el)
                }
              })
              if (this.newTerros12.length > 0) {
                this.lineChart.data.datasets[1].data.push(this.newTerros12[0].value);
              }
              if (this.newTerros12.length > 1) {
                this.lineChart.data.datasets[2].data.push(this.newTerros12[1].value);
              }
              if (this.newTerros12.length > 2) {
                this.lineChart.data.datasets[3].data.push(this.newTerros12[2].value);
              }
            }
            if (el.attributes.jxct_npk) {
              this.lineChart.data.datasets[4].data.push(el.attributes.jxct_npk[0].value);
              this.lineChart.data.datasets[5].data.push(el.attributes.jxct_npk[1].value);
              this.lineChart.data.datasets[6].data.push(el.attributes.jxct_npk[2].conversion_value);
            }
          }
        });
        const selectedTypes = sens.attributes.components.filter((el: any) => el.isOn).map((el: any) => el.sensor_type);
        this.lineChart.options.plugins.legend.labels.filter = (item: any) => {
          if (selectedTypes.includes("PH") && item.datasetIndex === 0) {
            return true;
          }
          if (selectedTypes.includes("T12") && item.datasetIndex >= 1 && item.datasetIndex <= 3) {
            return true;
          }
          if (selectedTypes.includes("NPK") && item.datasetIndex >= 4 && item.datasetIndex <= 6) {
            return true;
          }
          return false;
        };
        this.lineChart.update();
      });
    } else {
      this.spinner = false;
      this.clearAll();
    }
  }

  clearAll() {
    this.buttonStates2 = this.componentsD.map(group => {
      let groupButtonStates: { [key: string]: boolean } = {};
      group.attributes.components.forEach((button: any) => {
        groupButtonStates[button.isOn] = false;
        button.isOn = false;
      });
      return groupButtonStates;
    });
    this.lastDeviceComponents = [];
    this.lineChart.data.labels = [];
    this.lineChart.data.datasets.forEach((dataset: any) => dataset.data = []);
    this.lineChart.options.plugins.legend.labels.filter = (item: any, chart: any) => {
      return false
    }
    this.lineChart.update();
  }

}